/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateProjectRequest } from '../models/CreateProjectRequest';
import type { GetProjectResponse } from '../models/GetProjectResponse';
import type { PageableProjectResponse } from '../models/PageableProjectResponse';
import type { UpdateProjectRequest } from '../models/UpdateProjectRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProjectApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create project
   * @param requestBody Create project body schema
   * @returns any Success create response
   * @throws ApiError
   */
  public createProject(
    requestBody?: CreateProjectRequest,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/project/',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get all projects
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableProjectResponse Get project response
   * @throws ApiError
   */
  public getProjects(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/project',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get all projects
   * @param id
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableProjectResponse Get project response
   * @throws ApiError
   */
  public getProjectsByClientId(
    id: string,
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/project/client/{id}',
      path: {
        'id': id,
      },
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get project by id
   * @param id
   * @returns GetProjectResponse Get project response
   * @throws ApiError
   */
  public getProjectById(
    id: string,
  ): CancelablePromise<GetProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/project/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * delete project by id
   * @param id
   * @returns any deleted
   * @throws ApiError
   */
  public deleteProjectById(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/project/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Update project by id
   * @param id
   * @param requestBody
   * @returns GetProjectResponse Get project response
   * @throws ApiError
   */
  public updateProject(
    id: string,
    requestBody?: UpdateProjectRequest,
  ): CancelablePromise<GetProjectResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/project/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
